import { Component, OnInit } from '@angular/core';
import { UserService } from '../shared/user.service';
import { HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import { FeedbackService } from '../service/feedback.service';
import { Form161Service } from '../service/form161.service';

@Component({
    selector: 'app-form161',
    templateUrl: './form161.component.html',
    styleUrls: ['./form161.component.css']
})
export class Form161Component implements OnInit {

    public userDetails: any;

    listcustomer: any[] = [];
    selectedCustomerId: any = null;
    listEmployees: any[] = [];
    selectedEmployee: any = null;
    listFundInstitutions: any[] = [];
    selectedFundInstitution: any = null;

    msgs: any[] = [];



    constructor(private userService: UserService, private form161Service: Form161Service, private router: Router) { }

    ngOnInit() {

        this.userService.getUserClaims().subscribe((data: any) => {
            this.userDetails = data;
            if (this.userDetails && (this.userDetails.ClientRoleSupport || this.userDetails.ClientRoleAdministration  || this.userDetails.ClientRoleSemiAdministrator)) {
                this.form161Service.getCustomers().subscribe((result: any) => {
                    this.listcustomer = result;
                    this.listcustomer.unshift({ label: 'בחר מעסיק', value: null });
                },
                    (err: HttpErrorResponse) => {
                        this.showMessage('error', '', 'תקלה בקבלת רשימת מעסיקים');
                    });
            }
            else {
                this.customerSelected();
            }


        },
            (err: HttpErrorResponse) => {
                this.userDetails = null;
            });




    }

    customerSelected() {
        this.form161Service.GetEmployees(this.selectedCustomerId).subscribe((result: any) => {
            this.listEmployees = result;
            this.listEmployees.unshift({ label: 'בחר עובד', value: null });
        },
            (err: HttpErrorResponse) => {
                this.showMessage('error', '', 'תקלה בקבלת רשימת עובדים למעסיק');
            });
    }

    employeeSelected() {
        this.form161Service.GetFundInstitution(this.selectedCustomerId, this.selectedEmployee).subscribe((result: any) => {
            this.listFundInstitutions = result;
            this.listFundInstitutions.unshift({ label: 'בחר קופה', value: null });
        },
            (err: HttpErrorResponse) => {
                this.showMessage('error', '', 'תקלה בקבלת רשימת קופות לעובד');
            });
    }

    fundInstitutionSelected() {
        //
    }

    send161() {
        this.form161Service.send161(this.selectedCustomerId, this.selectedEmployee, this.selectedFundInstitution).subscribe((result: any) => {
            this.showMessage('success', '', 'בקשה לטופס 161 שודרה בהצלחה');
        },
            (err: HttpErrorResponse) => {
                this.showMessage('error', '', 'תקלה בשידור בקשה לטופס 161');
            });
    }


    showMessage(type, summaryMessage, message) {
        this.msgs = [];
        this.msgs.push({ severity: type, summary: summaryMessage, detail: message });   //type='success'/'error'/'warn'/'success'
    }


}



// WEBPACK FOOTER //
// C:/ProjectsOnGit/USilence/USilence/Client/src/app/form161/form161.component.ts